import { RangeSlider } from "lib/miolo";
import formatMoneyValue from "components/utils/formatMoneyValue";
import { useState } from "react";
import { connectRange } from "react-instantsearch-dom";
import * as palette from "../../palette";

type TRefineArguments = {
  min?: number;
  max?: number;
};

interface IConnectedMoneySliderRangeProps {
  label: string;
  accessibilityLabels: [string, string];
  refine: (refinement: TRefineArguments) => void;
  min?: number;
  max?: number;
  currentRefinement: {
    min?: number;
    max?: number;
  };
}

function ConnectedMoneySliderRange({
  label,
  accessibilityLabels,
  refine,
  currentRefinement,
  min,
  max,
}: IConnectedMoneySliderRangeProps) {
  const [willUpdateToValues, setWillUpdateToValues] = useState<ReadonlyArray<number> | null>(null);
  const canFilter = min !== undefined && max !== undefined && min < max;

  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 20,
      }}
    >
      <div
        css={{
          display: "flex",
          justifyContent: "space-between",
          color: palette.mariner,
          fontWeight: "bold",
          fontSize: 14,
          letterSpacing: 1,
        }}
      >
        <strong
          css={{
            fontWeight: 700,
          }}
        >
          {label}
        </strong>

        {willUpdateToValues ? (
          <strong
            css={{
              fontWeight: 700,
              color: palette.baliHai,
            }}
          >
            {formatMoneyValue(willUpdateToValues[0] || 0, "short")} —{" "}
            {formatMoneyValue(willUpdateToValues[1] || 0, "short")}
          </strong>
        ) : (
          <strong
            css={{
              fontWeight: 700,
            }}
          >
            {formatMoneyValue(currentRefinement.min || 0, "short")} —{" "}
            {formatMoneyValue(currentRefinement.max || 0, "short")}
          </strong>
        )}
      </div>

      {canFilter && (
        <RangeSlider
          disabled={!canFilter}
          domain={[min || 0, max || 0]}
          values={[currentRefinement.min || 0, currentRefinement.max || 0]}
          labels={accessibilityLabels}
          onUpdate={setWillUpdateToValues}
          onChange={([min, max]) => {
            setWillUpdateToValues(null);

            // eslint-disable-next-line no-restricted-globals
            if (isNaN(min) || isNaN(max)) {
              refine({
                min: undefined,
                max: undefined,
              });
              return;
            }

            refine({
              min,
              max,
            });
          }}
        />
      )}

      {min === undefined && max === undefined && (
        <small css={{ fontWeight: 500, letterSpacing: 1, color: palette.baliHai }}>Carregando...</small>
      )}

      {!canFilter && max !== undefined && (
        <RangeSlider
          disabled={true}
          domain={[0, max || 0]}
          values={[0, max || 0]}
          labels={accessibilityLabels}
          onUpdate={() => {
            // ...
          }}
          onChange={() => {
            // ...
          }}
        />
      )}
    </div>
  );
}

export default connectRange(ConnectedMoneySliderRange);
